import { render, staticRenderFns } from "./DiamondSwiper.vue?vue&type=template&id=5c2315c1&scoped=true&"
import script from "./DiamondSwiper.vue?vue&type=script&lang=ts&"
export * from "./DiamondSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./DiamondSwiper.vue?vue&type=style&index=0&id=5c2315c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2315c1",
  null
  
)

export default component.exports